import { useServiceFolderLevel } from '@church/data'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { PlansPanel } from '../components/services/ServicesPanels.tsx'
import { useBreadcrumbs } from '../lib/breadcrumbs.ts'
import { folderCrumbs, sectionCrumbs } from '../lib/services-crumbs.ts'

/**
 * Plans: the folders, one level at a time (`?folder=`: the one being looked
 * into), its folders first and then its service types. The folder is in the
 * address, so Back and a shared link land on the same level.
 */
export const Route = createFileRoute('/_authed/_shell/services/_sections/plans/')({
  validateSearch: z.object({ folder: z.uuid().optional() }),
  component: PlansScreen,
})

function PlansScreen() {
  const { folder } = Route.useSearch()
  const navigate = useNavigate()
  const level = useServiceFolderLevel(folder ?? null)
  // Services › Plans › Main campus › Youth.
  useBreadcrumbs(folder ? folderCrumbs(level.path) : sectionCrumbs('Plans'))
  return (
    <PlansPanel
      typeId=""
      folderId={folder ?? null}
      setTypeId={(typeId) => void navigate({ to: '/services/types/$typeId', params: { typeId } })}
    />
  )
}
